import { defineMessages } from 'react-intl'

export default defineMessages({
  weightForAge: {
    id: 'growthChart.weightForAge',
    defaultMessage: 'Weight for Age'
  },
  heightForAge: {
    id: 'growthChart.heightForAge',
    defaultMessage: 'Height for Age'
  },
  bmiForAge: {
    id: 'growthChart.bmiForAge',
    defaultMessage: 'BMI for Age'
  },
  headCircumferenceForAge: {
    id: 'growthChart.headCircumferenceForAge',
    defaultMessage: 'Head Circumference for Age'
  },
  male: {
    id: 'growthChart.male',
    defaultMessage: 'Male'
  },
  female: {
    id: 'growthChart.female',
    defaultMessage: 'Female'
  },
  ageMonths: {
    id: 'growthChart.ageMonths',
    defaultMessage: 'Age (months)'
  },
  weightKg: {
    id: 'growthChart.weightKg',
    defaultMessage: 'Weight (kg)'
  },
  heightCm: {
    id: 'growthChart.heightCm',
    defaultMessage: 'Height (cm)'
  },
  bmiUnit: {
    id: 'growthChart.bmiUnit',
    defaultMessage: 'BMI (kg/m²)'
  },
  headCircumferenceCm: {
    id: 'growthChart.headCircumferenceCm',
    defaultMessage: 'Head Circumference (cm)'
  },
  noDataMessage: {
    id: 'growthChart.noDataMessage',
    defaultMessage: 'No {measurement} measurements found in visit records.'
  },
  p3: {
    id: 'growthChart.p3',
    defaultMessage: '3rd percentile'
  },
  p15: {
    id: 'growthChart.p15',
    defaultMessage: '15th percentile'
  },
  p50: {
    id: 'growthChart.p50',
    defaultMessage: '50th percentile (median)'
  },
  p85: {
    id: 'growthChart.p85',
    defaultMessage: '85th percentile'
  },
  p97: {
    id: 'growthChart.p97',
    defaultMessage: '97th percentile'
  },
  patientData: {
    id: 'growthChart.patientData',
    defaultMessage: 'Patient data'
  },
  normalRange: {
    id: 'growthChart.normalRange',
    defaultMessage: 'Normal (15th–85th)'
  },
  borderlineRange: {
    id: 'growthChart.borderlineRange',
    defaultMessage: 'Borderline (3rd–15th / 85th–97th)'
  },
  abnormalRange: {
    id: 'growthChart.abnormalRange',
    defaultMessage: 'Abnormal (<3rd / >97th)'
  },
  summaryTitle: {
    id: 'growthChart.summaryTitle',
    defaultMessage: 'Measurement summary'
  },
  summaryPoints: {
    id: 'growthChart.summaryPoints',
    defaultMessage: '{count} {count, plural, one {point} other {points}}'
  },
  viewCharts: {
    id: 'growthChart.viewCharts',
    defaultMessage: 'View growth charts'
  }
})
